import { DecisionHistoryRecordV2 } from "src/api/decisionHistoryV2/decisionHistoryQueries";
import { FlowDbShallow, FlowVersionDbShallow } from "src/clients/flow-api";
import {
  GetDecisionsParamsBaseOutputOriginTypesEnum,
  HistoricalDecisionApiResponse,
} from "src/clients/history_v3";
import {
  SourceDetails,
  SourceDetailType,
} from "src/flow/decisionHistory/SourcePill";
import { Job } from "src/jobs/types";

const isV2Record = (
  record: DecisionHistoryRecordV2 | HistoricalDecisionApiResponse,
): record is DecisionHistoryRecordV2 => {
  return (
    "parent_flow_id" in record &&
    "parent_flow_version_id" in record &&
    "parent_decision_id" in record
  );
};

export const getSourceDetails = (
  record: DecisionHistoryRecordV2 | HistoricalDecisionApiResponse,
  parentFlows: FlowDbShallow[],
  potentialParentVersions: FlowVersionDbShallow[],
  jobs: Job[],
): SourceDetails => {
  if (isV2Record(record)) {
    if (
      record.parent_flow_id &&
      record.parent_flow_version_id &&
      record.parent_decision_id
    ) {
      const parentFlow = parentFlows.find(
        (parentFlow) => parentFlow.id === record.parent_flow_id,
      );
      const parentVersion = potentialParentVersions?.find(
        (potentialParentVersion) =>
          potentialParentVersion?.id === record.parent_flow_version_id,
      );
      return {
        type: SourceDetailType.ParentFlow,
        parentFlow,
        parentVersion,
        parentDecisionId: record.parent_decision_id,
      };
    }
    if (record.response.metadata.job_run_id) {
      const job = jobs.find(
        (job) => job.id === record.response?.metadata?.job_id,
      );
      return {
        type: SourceDetailType.Job,
        job: job,
        runId: record.response.metadata.job_run_id,
      };
    } else return { type: SourceDetailType.ApiCall };
  } else {
    if (
      record.origin.type ===
      GetDecisionsParamsBaseOutputOriginTypesEnum.API_CALL
    ) {
      return { type: SourceDetailType.ApiCall };
    } else if (
      record.origin.type === GetDecisionsParamsBaseOutputOriginTypesEnum.FLOW
    ) {
      return {
        type: SourceDetailType.ParentFlow,
        parentFlow: parentFlows.find(
          (parentFlow) => parentFlow.id === record.origin.parent_flow_id,
        ),
        parentVersion: potentialParentVersions?.find(
          (potentialParentVersion) =>
            potentialParentVersion?.id === record.origin.parent_flow_version_id,
        ),
        parentDecisionId: record.origin.parent_decision_id,
      };
    } else {
      const job = jobs.find((job) => job.id === record.origin.job_id);
      return {
        type: SourceDetailType.Job,
        job: job,
        runId: record.origin.job_run_id!,
      };
    }
  }
};
